module.exports = __webpack_public_path__ + "img/icon_left_point.86997902.svg";